<span style="font-weight: 500;">{{ value.split("_")[0]}}</span>
